module.exports = __webpack_public_path__ + "static/media/gyanvaibhav.0b95c9cf.jpg";